export default "__VITE_ASSET__DwTsOCQC__"